"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var constants_1 = require("playable/dist/src/constants");
var lodash_1 = require("lodash");
var PlaybackSuccessLogger = /** @class */ (function (_super) {
    tslib_1.__extends(PlaybackSuccessLogger, _super);
    function PlaybackSuccessLogger(props) {
        var _this = _super.call(this, props) || this;
        _this.onPlaybackStateChange = function (_a) {
            var nextState = _a.nextState;
            switch (nextState) {
                case constants_1.EngineState.PLAY_REQUESTED:
                    _this._needToLogPlayDone = true;
                    _this.logPlayRequest();
                    break;
                case constants_1.EngineState.PLAYING:
                    if (_this._needToLogPlayDone) {
                        _this.logPlayDone();
                        _this._needToLogPlayDone = false;
                    }
                    break;
                default:
                    break;
            }
        };
        _this.subscribeToEvents();
        return _this;
    }
    PlaybackSuccessLogger.prototype.componentWillUnmount = function () {
        this.unSubscribeFromEvents();
    };
    PlaybackSuccessLogger.prototype.subscribeToEvents = function () {
        var eventEmitter = this.props.eventEmitter;
        eventEmitter.on(constants_1.VIDEO_EVENTS.STATE_CHANGED, this.onPlaybackStateChange);
    };
    PlaybackSuccessLogger.prototype.unSubscribeFromEvents = function () {
        var eventEmitter = this.props.eventEmitter;
        eventEmitter.off(constants_1.VIDEO_EVENTS.STATE_CHANGED, this.onPlaybackStateChange);
    };
    PlaybackSuccessLogger.prototype.logPlayRequest = function () {
        var _a = this.props, videoID = _a.videoID, channelID = _a.channelID, engine = _a.engine, logTryFunction = _a.logTryFunction;
        var videoUrl = (0, lodash_1.get)(engine, 'attachedAdapter.currentUrl', null);
        logTryFunction({
            videoID: videoID,
            channelID: channelID,
            videoUrl: videoUrl,
        });
    };
    PlaybackSuccessLogger.prototype.logPlayDone = function () {
        var _a = this.props, videoID = _a.videoID, channelID = _a.channelID, engine = _a.engine, logSuccessFunction = _a.logSuccessFunction;
        var videoUrl = (0, lodash_1.get)(engine, 'attachedAdapter.currentUrl', null);
        logSuccessFunction({
            videoID: videoID,
            channelID: channelID,
            videoUrl: videoUrl,
        });
    };
    PlaybackSuccessLogger.prototype.render = function () {
        return null;
    };
    PlaybackSuccessLogger.propTypes = {
        videoID: prop_types_1.default.string.isRequired,
        channelID: prop_types_1.default.string.isRequired,
        logTryFunction: prop_types_1.default.func.isRequired,
        logSuccessFunction: prop_types_1.default.func.isRequired,
        eventEmitter: prop_types_1.default.object,
        engine: prop_types_1.default.object,
    };
    return PlaybackSuccessLogger;
}(react_1.default.Component));
exports.default = PlaybackSuccessLogger;
//# sourceMappingURL=playback-success-logger.js.map